import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdvancedRealTimeChart } from 'react-ts-tradingview-widgets';
import styled from 'styled-components';

const Styles = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: center;
  color: #888;
`;

const IXICTradingView: React.FC = React.memo(() => {
  const { t } = useTranslation();
  return (
    <div>
      <AdvancedRealTimeChart
        symbol="IXIC"
        width="100%"
        height={400}
        interval="D"
        hide_top_toolbar
        hide_side_toolbar
      />
      <Styles>
        <h5>{t('ixic_price_trading_view')}</h5>
      </Styles>
    </div>
  );
});

export default IXICTradingView;
